export const HOME = "/";
export const CASHBACK_WIZARD_START = "/cashback-wizard-start";
export const YOUR_DISCOUNT = "#your-discount";
export const FAQS = "#faq";
export const FORUM = "https://forum.rentablo.de/";
export const BLOG = "https://blog.rentablo.de/";
export const ABOUT_US = "https://wealthapi.eu/ueber-uns/";
export const LOGIN = "/login";
export const PRIVACY = "/privacy";
export const BUY = "https://rentablo.de/angebote-finanzmanager";
